<template>
  <div>
    <div class="DownloadMaterialsText">
      <div class="Text">
        资料下载
        <a href="javascript:;" class="SeeMore" @click="SeeMore">查看更多></a>
      </div>
    </div>
    <div class="DownloadDataCss">
      <DownloadDataSwiper ref="DownloadDataSwiper" :SwiperList="SwiperList"></DownloadDataSwiper>
    </div>
  </div>
</template>

<script>
import DownloadDataSwiper from './DownloadDataSwiper/DownloadDataSwiper.vue'
export default {
  props: {
    // 轮播数据
    SwiperList: {
      type: Array
    }
  },
  components: {
    DownloadDataSwiper
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    SeeMore() {
      this.$router.push({
        path: JSON.parse(localStorage.getItem("MenusData")).CusWebMenus.filter(item => item.NodeID == 65)[0].Path
      })
    }
  }
}
</script>

<style lang="less">
.DownloadMaterialsText {
  margin-top: 60px;
  height: 100px;
  //   border: 1px solid cornflowerblue;
  display: flex;
  justify-content: center;
  align-items: center;

  .Text {
    width: 340px;
    height: 155px;
    // border: 1px solid saddlebrown;
    color: #fff;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    line-height: 120px;
    overflow: hidden;
    position: relative;

    .SeeMore {
      height: 50%;
      width: 100%;
      display: block;
      font-weight: 400;
      color: #ffffff;
      font-size: 14px;
      text-decoration: none;
      font-weight: 500;
      position: absolute;
      top: -20px;
      transform: translate(0%, 65%);
    }
    .SeeMore::before {
      content: "提供公司的各类常规资质的查看及其下载    ";
      color: #ffffff;
      margin-right: 10px;
    }
  }
}
</style>